/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取专题项目模板导航栏
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  specialLayoutId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.SubjectProductNavigationDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/subject-info/product/navigation/${specialLayoutId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
